import { ExternalLink, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTransactionDocumentDownload } from "@/hooks/useTransactionDocumentDownload";
import { useCompany } from "@/contexts/CompanyContext";

interface ViewTransactionDocumentButtonProps {
  transactionId: number;
  transactionType: string;
}

export function ViewTransactionDocumentButton({ transactionId, transactionType }: Readonly<ViewTransactionDocumentButtonProps>) {
  const { isDownloading, downloadTransactionDocument } = useTransactionDocumentDownload();
  const { selectedCompany } = useCompany();

  if (transactionType !== "invoice" && transactionType !== "credit_note") {
    return null;
  }

  if (selectedCompany?.linkedProductName !== "Financials") {
    return null;
  }

  return (
    <Button
      onClick={() => downloadTransactionDocument(transactionId)}
      disabled={isDownloading}
      className="gap-2 flex-1"
    >
      {isDownloading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <ExternalLink className="h-4 w-4" />
      )}
      {isDownloading ? "Downloading..." : "View Financials Invoice"}
    </Button>
  );
}
